// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Axios from './util/axios-config.js'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import vueFilter from './util/filter.js'
import linq from 'linq';
import moment from 'moment';
import 'moment/locale/zh-cn'
import DomPortal from "vue-dom-portal";
import cookies from "vue-cookies"
import 'babel-polyfill'
import { cascader, Upload, Input, Button, Dialog, Col, Row, Table, TableColumn, MessageBox, Tabs, TabPane } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(cascader)
Vue.use(Upload);
Vue.use(Input)
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Col)
Vue.use(Row)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tabs)
Vue.use(TabPane)
moment.locale('zh-cn');

vueFilter(Vue);
// import style
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.config.productionTip = false;
import store from './util/store'
//#region 播放器
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
import VideoPlayer from "vue-video-player";
const hls = require("videojs-contrib-hls");

Vue.use(hls);
Vue.use(VideoPlayer);
Vue.use(DomPortal);
//#endregion

Vue.use(ViewUI);

Vue.prototype.$Axios = Axios;
Vue.prototype.$Linq = linq;
Vue.prototype.$filterNull = filterNull;
Vue.prototype.$cookies = cookies;
Vue.prototype.$confirm = MessageBox.confirm;
function filterNull (object) {
  let arr = Object.keys(object),
    newObj = {};
  arr.forEach(x => {
    if (object[x] !== null) {
      newObj[x] = object[x];
    }
  })
  return newObj;
};

import Breadcrumb from '@/components/common/breadcrumb/index';
import BreadcrumbItem from '@/components/common/breadcrumb-item/index';
Vue.component(Breadcrumb.name, Breadcrumb);
Vue.component(BreadcrumbItem.name, BreadcrumbItem);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js